var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205.434,
    height: 230.532,
    viewBox: "0 0 205.434 230.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rer",
    transform: "translate(-12.766 -168.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_42a74bff",
    "data-name": "#42a74bff",
    transform: "translate(-106 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M262.62,108.05c23.86,5.97,46.03,19.4,61.58,38.55-11.19,9.44-22.47,18.77-33.5,28.4-10.35-11.17-23.42-20.19-38.4-23.68C255.54,136.85,259.38,122.52,262.62,108.05Z",
    fill: "#42a74b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M168.44,117.67a32.825,32.825,0,0,1,32.65,9.17,33.17,33.17,0,1,1-51.44,41.47c-5.61-7.85-6.94-18.21-4.58-27.46C148.23,129.83,157.18,120.43,168.44,117.67Z",
    fill: "#42a74b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M118.77,221.57c14.71-.02,29.41.02,44.12-.02.45,17.27,6.33,34.64,17.97,47.59,12.71,14.79,31.62,24.17,51.18,24.66a70.637,70.637,0,0,0,46.98-14.75c4.31-3.12,7.87-7.08,11.65-10.78,11.04,9.54,22.24,18.92,33.45,28.27-.49.71-.96,1.42-1.43,2.13-24.16,28.16-62.57,43.38-99.47,39.24A116.851,116.851,0,0,1,118.77,221.57Z",
    fill: "#42a74b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareem);
export default __webpack_public_path__ + "static/media/careem.cbd0afba3de901dfc56b4b6775315a06.svg";
export { ForwardRef as ReactComponent };